import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const CreateBanner = lazy(() => import("@/pages/ControlPanel/Nested/Banner/CreateBanner"));
const EditBanner = lazy(() => import("@/pages/ControlPanel/Nested/Banner/EditBanner"));

const urlsConfig = new UrlsConfig();

export function bannerRoutes() {
    return (
      <>
          <Route path={urlsConfig.inControlPanelBannerCreate.to} element={<CreateBanner/>}/>
          <Route path={`${urlsConfig.inControlPanelBannerEdit.to}/:id`} element={<EditBanner/>}/>
      </>
    );
}
